import { urlFor } from "@/utils/client";
import { IPartner, IPartners } from "@/utils/types";
import Image from "next/image";
import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

export function Partners(props: IPartners) {
  // Shuffle function to randomize array elements
  function shuffle(array: IPartner[]): IPartner[] {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }

  const partners = props.partners ?? [];

  const [firstMarqueePartners, setFirstMarqueePartners] =
    useState<IPartner[]>(partners);
  const [secondMarqueePartners, setSecondMarqueePartners] =
    useState<IPartner[]>(partners);
  const [thirdMarqueePartners, setThirdMarqueePartners] =
    useState<IPartner[]>(partners);

  useEffect(() => {
    if (partners.length === 0) return;
    setFirstMarqueePartners(shuffle([...partners]));
    setSecondMarqueePartners(shuffle([...partners]));
    setThirdMarqueePartners(shuffle([...partners]));
  }, [partners]);

  const partnerSize = "h-[100px] w-[100px]";

  const gradientColor = props.noBg
    ? "#F3F3F3"
    : props.invert
      ? "#FFFFFF"
      : "#1D1D1D";

  return (
    <div
      className={`${props.invert ? "bg-white" : "bg-darkGrey"} ${
        props.noBg ? "!bg-grey" : ""
      } max-w-page mx-auto`}
    >
      <div
        className={`flex flex-col items-center component-gap ${
          props.noBg ? "pb-0" : "py-16"
        } ${props.invert ? "text-darkGrey" : "text-white"} text-center`}
      >
        {props.title && (
          <div className="flex flex-col component-gap max-w-5xl">
            <p className="heading">{props.title}</p>
            <p className="opacity-80">{props.description}</p>
          </div>
        )}
        {[{ partners: firstMarqueePartners, direction: "left" as const }].map(
          (row, idx) => (
            <Marquee
              key={idx}
              speed={25}
              direction={row.direction}
              gradient
              gradientColor={gradientColor}
              autoFill
            >
              {row.partners.map((partner, i) => {
                if (!partner.logo?.image) return null;
                const img = (
                  <Image
                    className={`aspect-[4/2] ${
                      partner.link ? "" : "mr-16"
                    } ${partnerSize} object-contain object-center ${
                      props.invert ? "invert opacity-50" : ""
                    }`}
                    width={500}
                    height={500}
                    alt={partner.logo?.caption ?? ""}
                    src={urlFor(partner.logo.image).url()}
                  />
                );
                return partner.link ? (
                  <a
                    key={i}
                    href={partner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mr-8"
                  >
                    {img}
                  </a>
                ) : (
                  <span key={i} className="mr-8">
                    {img}
                  </span>
                );
              })}
            </Marquee>
          ),
        )}
      </div>
    </div>
  );
}
